<!--BIENVENIDA -->
<form action="" autocomplete="off" [formGroup]="formStepWelcome">
  <p class="text-form">
    Solamente los campos marcados con (*) son obligatorios.
  </p>
  <div class="form">
    <!-- NOMBRES -->
    <mat-form-field appearance="fill">
      <mat-label>Nombre(s)</mat-label>
      <input
        (keyup)="checkEvent()"
        matInput
        placeholder="Ingrese su nombre completo"
        formControlName="firstName"
        oninput="this.value = this.value.toUpperCase()"
        (keydown)="isLetter($event)"
        onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
      />
      <mat-error
        *ngIf="
          formStepWelcome.controls['firstName'].invalid &&
          formStepWelcome.controls['firstName'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcome.controls['firstName'].errors &&
            formStepWelcome.controls['firstName'].errors['required']
          "
          >Debe completar este campo</span
        >
        <span
          *ngIf="
            formStepWelcome.controls['firstName'].errors &&
            formStepWelcome.controls['firstName'].errors['pattern']
          "
          >Verifique los espacios en blanco</span
        >
      </mat-error>
      <mat-error
        *ngIf="formStepWelcome.controls['firstName'].hasError('maxlength')"
        >Máximo 45 caracteres.
      </mat-error>
      <mat-error
        *ngIf="formStepWelcome.controls['firstName'].hasError('minlength')"
        >Mínimo 2 caracteres.
      </mat-error>
    </mat-form-field>
    <!-- APELLIDO PATERNO -->
    <mat-form-field appearance="fill">
      <mat-label>Apellido paterno</mat-label>
      <input
        matInput
        placeholder="Ingrese su apellido paterno"
        formControlName="lastName"
        oninput="this.value = this.value.toUpperCase()"
        (keydown)="isLetter($event)"
        onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
        (keyup)="checkEvent()"
      />
      <mat-error
        *ngIf="
          formStepWelcome.controls['lastName'].invalid &&
          formStepWelcome.controls['lastName'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcome.controls['lastName'].errors &&
            formStepWelcome.controls['lastName'].errors['required']
          "
          >Debe completar este campo</span
        >
        <span
          *ngIf="
            formStepWelcome.controls['lastName'].errors &&
            formStepWelcome.controls['lastName'].errors['pattern']
          "
          >Verifique los espacios en blanco</span
        >
      </mat-error>
      <mat-error
        *ngIf="formStepWelcome.controls['lastName'].hasError('maxlength')"
        >Máximo 45 caracteres.
      </mat-error>
      <mat-error
        *ngIf="formStepWelcome.controls['lastName'].hasError('minlength')"
        >Mínimo 2 caracteres.
      </mat-error>
    </mat-form-field>
    <!-- APELLIDO MATERNO -->
    <mat-form-field appearance="fill">
      <mat-label>Apellido materno</mat-label>
      <input
        (keyup)="checkEvent()"
        matInput
        placeholder="Ingrese su apellido materno"
        formControlName="secondLastName"
        oninput="this.value = this.value.toUpperCase()"
        (keydown)="isLetter($event)"
        onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
      />
      <mat-error
        *ngIf="formStepWelcome.controls['secondLastName'].hasError('maxlength')"
        >Máximo 45 caracteres.
      </mat-error>
      <mat-error
        *ngIf="formStepWelcome.controls['secondLastName'].hasError('minlength')"
        >Mínimo 2 caracteres.
      </mat-error>
      <mat-error *ngIf="formStepWelcome.controls['secondLastName'].touched">
        <span
          *ngIf="
            formStepWelcome.controls['secondLastName'].errors &&
            formStepWelcome.controls['secondLastName'].errors['pattern']
          "
          >Verifique los espacios en blanco
        </span>
      </mat-error>
    </mat-form-field>
    <!-- CORREO ELECTRONICO -->
    <mat-form-field appearance="fill">
      <mat-label>Correo electrónico</mat-label>
      <input
        (keyup)="checkEvent()"
        matInput
        placeholder="Ingrese su correo electrónico"
        [formControl]="emailCtrl"
        type="email"
        (keydown)="deleteSpaceInit($event)"
        matTooltip="Verifica que este escrito correctamente tu correo ya que deberás validarlo y será el oficial donde recibirás comunicaciones de parte de Vemo."
      />
      <mat-error *ngIf="emailCtrl.invalid && emailCtrl.touched">
        <span *ngIf="emailCtrl.errors && emailCtrl.errors['required']"
          >Debe completar este campo</span
        >
      </mat-error>
      <mat-error *ngIf="emailCtrl.hasError('pattern')"
        >Formato incorrecto.
      </mat-error>
      <mat-error *ngIf="emailCtrl.hasError('emailEnd')" class="textProviders">
        Formato de email incorrecto.
      </mat-error>
      <mat-icon matSuffix>notification_important</mat-icon>
    </mat-form-field>
    <!-- CODIGO PAIS -->
    <div>
      <mat-form-field
        appearance="fill"
        style="width: 40%"
        matTooltip="Código país"
      >
        <mat-label>Código país</mat-label>
        <mat-select
          (selectionChange)="checkEvent()"
          formControlName="cellPhoneCountryCode"
        >
          <mat-option
            *ngFor="let opcion of phoneCountryCode"
            [value]="opcion.countryCode"
            class="margin-option"
          >
            <img src="{{ opcion.flag }}" class="image" />

            {{ opcion.phoneCode }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            formStepWelcome.controls['cellPhoneCountryCode'].invalid &&
            formStepWelcome.controls['cellPhoneCountryCode'].touched
          "
        >
          <span
            *ngIf="
              formStepWelcome.controls['cellPhoneCountryCode'].errors &&
              formStepWelcome.controls['cellPhoneCountryCode'].errors[
                'required'
              ]
            "
            >Debe completar este campo</span
          >
        </mat-error>
      </mat-form-field>
      <!-- TELEFONO CELULAR -->
      <mat-form-field appearance="fill" style="width: 60%">
        <mat-label>Teléfono celular</mat-label>
        <input
          appNumber
          (keyup)="checkEvent()"
          matInput
          placeholder="Ingrese su número de celular"
          formControlName="mobilePhoneNumber"
          matTooltip="Verifica que este escrito correctamente tu Teléfono ya que deberás validarlo y será el oficial donde recibirás comunicaciones de parte de Vemo."
        />
        <mat-error
          *ngIf="
            formStepWelcome.controls['mobilePhoneNumber'].invalid &&
            formStepWelcome.controls['mobilePhoneNumber'].touched
          "
        >
          <span
            *ngIf="
              formStepWelcome.controls['mobilePhoneNumber'].errors &&
              formStepWelcome.controls['mobilePhoneNumber'].errors['required']
            "
            >Debe completar este campo</span
          >
        </mat-error>
        <mat-error
          *ngIf="
            formStepWelcome.controls['mobilePhoneNumber'].hasError('pattern')
          "
          >Debe ingresar 10 caracteres.
        </mat-error>
        <mat-icon matSuffix>notification_important</mat-icon>
      </mat-form-field>
    </div>
    <!-- FECHA NACIMIENTO -->
    <mat-form-field appearance="fill">
      <mat-label>Fecha de nacimiento</mat-label>
      <input
        appNumber
        (keyup)="checkEvent()"
        matInput
        [matDatepicker]="dp"
        formControlName="dateOfBirth"
        placeholder="dd/mm/yyyy"
        [max]="getNow()"
      />
      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
      <mat-datepicker #dp></mat-datepicker>
      <mat-error
        *ngIf="
          formStepWelcome.controls['dateOfBirth'].invalid &&
          formStepWelcome.controls['dateOfBirth'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcome.controls['dateOfBirth'].errors &&
            formStepWelcome.controls['dateOfBirth'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
    </mat-form-field>
    <!-- MUNICIPIO RESIDENCIA -->
    <mat-form-field appearance="fill">
      <mat-label>Municipio de residencia</mat-label>
      <mat-select
        (selectionChange)="checkEvent()"
        [formControl]="municipalitiesCtrl"
        placeholder="Municipalidad de residencia"
        #singleSelect
      >
        <mat-option>
          <ngx-mat-select-search
            (blur)="checkEvent()"
            [formControl]="municipalitiesFilterCtrl"
            placeholderLabel="Buscar municipio..."
            noEntriesFoundLabel="'Ningún municipio con ese nombre. Si no encuentra su municipio en la lista no puede aplicar.'"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option
          *ngFor="let municipality of filteredMunicipalities | async"
          [value]="municipality.id"
        >
          {{ municipality.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="municipalitiesCtrl.invalid && municipalitiesCtrl.touched"
      >
        <span
          *ngIf="
            municipalitiesCtrl.errors && municipalitiesCtrl.errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
    </mat-form-field>
    <!-- COMO TE ENTERASTE -->
    <mat-form-field
      appearance="fill"
      matTooltip="¿Cómo te enteraste de nosotros?"
    >
      <mat-label>¿Cómo te enteraste de nosotros?</mat-label>
      <mat-select
        (selectionChange)="checkEvent()"
        formControlName="whereFindOutId"
      >
        <mat-option
          *ngFor="let opcion of waysFindOuts"
          [value]="opcion.id"
          (onSelectionChange)="validInputAnotherWayFindOut($event)"
        >
          {{ opcion.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          formStepWelcome.controls['whereFindOutId'].invalid &&
          formStepWelcome.controls['whereFindOutId'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcome.controls['whereFindOutId'].errors &&
            formStepWelcome.controls['whereFindOutId'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
    </mat-form-field>
    <!-- COMO TE ENTERASTE(OTRA) -->
    <mat-form-field
      appearance="fill"
      *ngIf="
        formStepWelcome.get('whereFindOutId')!.value ===
        'f166537b-a8f5-4bd5-b71c-651173b768be'
      "
    >
      <mat-label>Otra(especifique)</mat-label>
      <input
        (keyup)="checkEvent()"
        matInput
        placeholder="Ingrese donde trabaja"
        formControlName="anotherWayFindOut"
      />
      <mat-error
        *ngIf="
          formStepWelcome.controls['anotherWayFindOut'].invalid &&
          formStepWelcome.controls['anotherWayFindOut'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcome.controls['anotherWayFindOut'].errors &&
            formStepWelcome.controls['anotherWayFindOut'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
      <mat-error
        *ngIf="
          formStepWelcome.controls['anotherWayFindOut'].hasError('maxlength')
        "
        >Máximo 45 caracteres.
      </mat-error>
    </mat-form-field>
    <!-- COMO TE ENTERASTE -->
    <mat-form-field appearance="fill">
      <mat-label>¿Por qué medio deseas que te contactemos?</mat-label>
      <mat-select
        (selectionChange)="checkEvent()"
        formControlName="contactMediumType"
      >
        <mat-option
          *ngFor="let contactMedium of contactsMedium"
          [value]="contactMedium.code"
        >
          {{ contactMedium.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          formStepWelcome.controls['contactMediumType'].invalid &&
          formStepWelcome.controls['contactMediumType'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcome.controls['contactMediumType'].errors &&
            formStepWelcome.controls['contactMediumType'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
    </mat-form-field>
  </div>
  <!-- AVISO DE PRIVACIDAD -->
  <div class="margin-check">
    <mat-checkbox
      (change)="checkEvent()"
      formControlName="privacyNoticeAccepted"
    >
    </mat-checkbox>
    <p class="text-check">Acepto el Aviso de Privacidad</p>
    <button
      mat-icon-button
      aria-label="Example icon button with a vertical three dot icon"
      class="color-button"
      (click)="openNoticeOfPrivacyDialog()"
    >
      <mat-icon>help</mat-icon>
    </button>
  </div>
  <mat-error
    class="error"
    *ngIf="
      formStepWelcome.controls['privacyNoticeAccepted'].invalid &&
      formStepWelcome.controls['privacyNoticeAccepted'].touched
    "
  >
    <span
      *ngIf="
        formStepWelcome.controls['privacyNoticeAccepted'].errors &&
        formStepWelcome.controls['privacyNoticeAccepted'].errors['required']
      "
      >Es necesario aceptar terminos</span
    >
  </mat-error>
</form>
